import React from 'react';
import { Query } from '@apollo/client/react/components';

import NavigationItem from '../NavigationItem/NavigationItem';
import gql from 'graphql-tag';
import { CurrentUser } from './__generated__/CurrentUser';

export const CURRENT_USER_QUERY = gql`
    query CurrentUser {
        me {
            user {
                certifications
                isAdmin
            }
        }
    }
`;

export function BrowseProjectsNavigationItem() {
    const experimentEnabled = document.cookie.includes('99x_browseProjects=enabled');
    if (!experimentEnabled) {
        return null;
    }
    return (
        <Query<CurrentUser>
            query={CURRENT_USER_QUERY}
            notifyOnNetworkStatusChange
            fetchPolicy="cache-and-network"
        >
            {queryResult => {
                const { data } = queryResult;
                if (!data || !data.me || !data.me.user) {
                    return null;
                }
                const user = data.me.user;
                const certifications = user.certifications;
                if (!user.isAdmin && !certifications.includes('squarespace')) {
                    return null;
                }
                return (
                    <NavigationItem
                        label={'Browse projects'}
                        url="/projects/browse"
                        icon="notebook-3"
                        highlightNew={true}
                    />
                );
            }}
        </Query>
    );
}

export default function YourWorkMenu() {
    return (
        <div className="menu menu--constrained">
            <div className="menu__inner">
                <ul className="menu__item menu__item--action-list">
                    <NavigationItem
                        label={__('Contests')}
                        url="/contests/your-contests"
                        icon="folder-1"
                    />

                    <NavigationItem label={__('Projects')} url="/projects/active" icon="folder-1" />

                    <NavigationItem
                        label={__('Browse contests')}
                        url="/contests/browse"
                        icon="notebook-3"
                    />
                    <li className={'hidden'} data-globalnav-your-work-menu-browse-projects />
                </ul>
            </div>
        </div>
    );
}
